/**
 * Seleção de filas da tela de atendimentos.
 *
 * O `selectedQueueIds` nasce de um inicializador de `useState`, que roda UMA
 * vez — e no primeiro render o `user` do AuthContext ainda é `{}`. Quando o
 * usuário chega depois, a lista já congelou vazia e nada a corrige.
 *
 * Vazia ela não é inofensiva: o handler de socket do TicketsListCustom apaga
 * da tela (`notBelongsToUserQueues`) todo ticket que ganha fila. O
 * atendimento aparece sem fila, o bot atribui uma, e ele some — enquanto o F5
 * mostra tudo, porque a listagem vem da API, que decide pelo usuário no
 * servidor e ignora esta seleção.
 */

/** Filas salvas na sessão anterior que ainda pertencem ao usuário. */
export function savedQueueSelection(saved, userQueueIds) {
  if (!Array.isArray(saved) || !Array.isArray(userQueueIds)) return [];
  return saved.filter((id) => userQueueIds.includes(id));
}

/**
 * Precisa preencher a seleção com as filas do usuário?
 *
 * Só quando ela está vazia E as filas já chegaram — e apenas uma vez, para
 * não desfazer uma escolha manual de desmarcar tudo.
 */
export function needsQueueSync(selectedQueueIds, userQueueIds, alreadySynced) {
  if (alreadySynced) return false;
  if (!Array.isArray(userQueueIds) || userQueueIds.length === 0) return false;
  return !Array.isArray(selectedQueueIds) || selectedQueueIds.length === 0;
}
